import { FC, useCallback, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Heading,
  Stack,
  Link,
} from "@chakra-ui/react";
import { AppContext } from "../../../../AppContext";
import { links } from "../../helpers";

export const NavigationMenu: FC = () => {
  const { sidebarIsOpen, setSidebarIsOpen } = useContext(AppContext);

  const onClose = useCallback(() => {
    setSidebarIsOpen(false);
  }, [setSidebarIsOpen]);

  return (
    <Drawer
      isOpen={sidebarIsOpen}
      placement="left"
      onClose={onClose}
      // finalFocusRef={btnRef}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Меню</DrawerHeader>
        <DrawerBody>
          <Stack spacing="24px">
            {links.map(({ id, label, to }) => (
              <Link key={id} to={to} as={RouterLink} onClick={onClose}>
                {label}
              </Link>
            ))}
          </Stack>
        </DrawerBody>
        <DrawerFooter>
          <Heading>MDC, 2022</Heading>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
